module.exports = __webpack_public_path__ + "static/Kroger-9f83d58887840de0454397bf26b62487.png";